import styled, { css } from "styled-components";

export const Wrapper = styled.button`
  background-color: transparent;
  border: 0;
  display: flex;
  align-items: center;
  width: 100%;
  color: ${({ theme }) => theme.colors.lightGray};

  & + button {
    margin-top: 1rem;
  }
`;

export const WrapperDate = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 40px;
    background-color: ${theme.colors.lightGray};
    color: ${theme.colors.white};
    border-radius: 8px;
    font-size: 0.875rem;
    padding: 0.25rem 0;
  `}
`;

export const Description = styled.div`
  ${({ theme }) => css`
    flex: 1;
    margin-left: 0.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;

    > span {
      font-size: 0.875rem;
      color: ${theme.colors.black};
      opacity: 0.5;
    }
  `}
`;

export const AboutManagement = styled.div`
  ${({ theme }) => css`
    text-align: left;

    > p {
      color: ${theme.colors.black};
      margin: 0;
      line-height: 1;
    }

    > span {
      line-height: 1;
      color: ${theme.colors.black};
      opacity: 0.5;
      font-size: 0.75rem;
    }
  `}
`;
